import firebase from '../config/firebase.config';

const database = firebase.firestore();

const getBrowserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

/**
 * Resolve a user's timezone from membersDatabase with browser timezone fallback.
 * @param {string} userId
 * @returns {Promise<{success: boolean, timezone: string, source: string, error?: string}>}
 */
export async function getUserTimezoneFromMembersDatabase(userId) {
  try {
    if (!userId) {
      return {
        success: false,
        timezone: getBrowserTimezone(),
        source: 'fallback',
        error: 'userId is required',
      };
    }

    const memberDoc = await database
      .collection('membersDatabase')
      .doc(userId)
      .get();
    if (!memberDoc.exists) {
      return {
        success: true,
        timezone: getBrowserTimezone(),
        source: 'fallback',
      };
    }

    const memberData = memberDoc.data() || {};
    const timezone = memberData.timeZone;
    if (!timezone || typeof timezone !== 'string' || !timezone.trim()) {
      return {
        success: true,
        timezone: getBrowserTimezone(),
        source: 'fallback',
      };
    }

    return {
      success: true,
      timezone: timezone.trim(),
      source: 'membersDatabase',
    };
  } catch (error) {
    return {
      success: true,
      timezone: getBrowserTimezone(),
      source: 'fallback',
      error: error.message,
    };
  }
}

export { getBrowserTimezone };
